import React, { useEffect, useState } from 'react';
import {
  IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead,
  TablePagination, TableRow
} from '@material-ui/core';
import Axios from 'axios';
import { withRouter } from 'react-router-dom';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

import { API, prices } from '../../config';

const TablePaginationActions = (props) => {
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div style={{display: 'flex',flexDirection: 'row',width: '100%'}}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPageIcon />
      </IconButton>
    </div>
  );
}

const ResultsPage = ({match}) => {
  const [allowed, setAllowed] = useState(false);
  const [results, setResults] = useState([]);
  const [stats, setStats] = useState(null);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const getAllResults = async () => {
      try {
        const token = match && match.params && match.params.token ? match.params.token : ''
        const resp = await Axios.get(API.registerDraw + '/results', {
          headers: {
            Authorization: `bearer ${token}`
          }
        });
        if (resp.data.success) {
          setResults(resp.data.data);
          setAllowed(true);
        }
      } catch (e) {
        setAllowed(false);
      }
    };

    const getAllStats = async () => {
      try {
        const token = match && match.params && match.params.token ? match.params.token : ''
        const resp = await Axios.get(API.registerDraw + '/stats', {
          headers: {
            Authorization: `bearer ${token}`
          }
        });
        console.log(resp);
        if (resp.data.success) {
          setStats(resp.data.data);
          setAllowed(true);
        }
      } catch (e) {
        setAllowed(false);
      }
    };

    getAllResults();
    getAllStats();
  }, []); // eslint-disable-line

  return (
    <div className="page-wrapper">
      <div className="page-root">
        <main>
          <div className="result-view">
            {
              allowed && results && results.length > 0
                ? <div>
                    <div>
                      {
                        stats
                          && <div className="container mb-5">
                            <h2 className="pt-5">The distribution of Gifts</h2>
                            <div  style={{ backgroundColor : "#FFF", fontSize: "0.9rem" }}  className="row my-4">
                            {
                              Object.keys(stats).map((s) =>
                                <div className="col-md-3 my-2" key={s}>
                                  <div className="row">
                                    <div className="col-9"><b>{prices[s].name}</b></div>
                                    <div className="col-3">{stats[s]}</div>
                                  </div>
                                </div>
                              )
                            }
                            </div>
                          </div>
                      }
                    </div>
                    <TableContainer component={Paper}>
                      <Table aria-label="custom pagination table" size="small" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Price</TableCell>
                            <TableCell>Reference</TableCell>
                            <TableCell>User Name</TableCell>
                            <TableCell>User Email</TableCell>
                            <TableCell>User Mobile</TableCell>
                            <TableCell>Outlet</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {
                            (rowsPerPage > 0
                              ? results.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              : results
                            ).map((row) => (
                              <TableRow key={row.id} hover >
                                <TableCell component="th" scope="row">
                                  {row.id}
                                </TableCell>
                                <TableCell>
                                  {row.price.name}
                                </TableCell>
                                <TableCell>
                                  {row.reference}					  
                                </TableCell>
                                <TableCell>
                                  {row.user_name}
                                </TableCell>
                                <TableCell>
                                  {row.user_email}
                                </TableCell>
                                <TableCell>
                                  {row.user_mobile}
                                </TableCell>
                                <TableCell>
                                  {row.user_outlet}
                                </TableCell>
                              </TableRow>
                            ))
                          }
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Table>
                      <TableBody>
                        <TableRow>
                          <TablePagination
                            style={{width: '100%',display: 'flex',justifyContent: 'center',border: 'none'}}
                            rowsPerPageOptions={[10, 25, 50, { label: 'All', value: -1 }]}
                            colSpan={10}
                            count={results.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                              inputProps: { 'aria-label': 'rows per page' },
                              native: true,
                            }}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                          />
                        </TableRow>
                      </TableBody>
                    </Table>
                  </div>
                : <div>
                  <h2>Could not validate token. Please check the url and try again</h2>
                  </div>
            }
          </div>
        </main>
      </div>
    </div>
  );
};

export default withRouter(ResultsPage);
